// Full-document render of the sealy CustomerContentHubStoryPage: PageSkeleton
// (the React document shell) wrapping the hub header and the existing
// story-page body assembly. Both are gated on love_root -- the header matched
// the legacy partial's {% if love_root %}, and the body island's props
// require a non-null love_root (story pages only exist under a
// CustomerContentHubRootPage).
import React from "react";

import { templates } from "@reactivated";

import { CustomerContentHubHeader } from "../apps/customer-content-hub/CustomerContentHubHeader";
import { CustomerContentHubStoryPage as CustomerContentHubStoryPageBody } from "../apps/customer-content-hub/CustomerContentHubStoryPage";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.CustomerContentHubStoryPageDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        {props.love_root && (
            <>
                <CustomerContentHubHeader love_root={props.love_root} />
                <CustomerContentHubStoryPageBody
                    {...props}
                    love_root={props.love_root}
                />
            </>
        )}
    </PageSkeleton>
);
